'use strict';

/* ===== Helpers ===== */

function getAppRootUrl() {
    // "…/infos" or "…/infos/" → "…/"
    const path = window.location.pathname.replace(/\/infos\/?$/, '/');
    return window.location.origin + path;
}

function showInfosToast(message) {
    let toast = document.getElementById('infos-toast');
    if (!toast) {
        toast = document.createElement('div');
        toast.id = 'infos-toast';
        toast.className = 'infos-toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.remove('visible');
    // Force reflow so the transition replays when the same toast fires twice.
    void toast.offsetWidth;
    toast.classList.add('visible');
    window.clearTimeout(showInfosToast._timer);
    showInfosToast._timer = window.setTimeout(() => {
        toast.classList.remove('visible');
    }, 2400);
}

function isStandaloneDisplay() {
    if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) return true;
    // iOS Safari exposes navigator.standalone.
    return Boolean(window.navigator && window.navigator.standalone);
}

/* ===== Share button ===== */

async function shareSite() {
    const url = getAppRootUrl();
    const shareData = {
        title: 'MyPoo 💩',
        text: 'MyPoo — suis tes cacas avec humour, fais le point sur ta santé.',
        url,
    };

    if (navigator.share) {
        try {
            await navigator.share(shareData);
            return;
        } catch (err) {
            // AbortError = user cancelled ; rien à faire.
            if (err && err.name === 'AbortError') return;
            // Autre erreur → on tente le fallback clipboard.
        }
    }

    try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(url);
            showInfosToast('Lien copié 📋');
            return;
        }
    } catch (_) {
        // clipboard bloqué → prompt.
    }

    // Fallback ultime : prompt manuel.
    window.prompt('Copie ce lien pour partager MyPoo :', url);
}

function bindShareButton() {
    const btn = document.getElementById('infos-share-btn');
    if (!btn) return;
    btn.addEventListener('click', () => { void shareSite(); });
}

/* ===== PWA install ===== */

let _deferredInstallPrompt = null;

function markInstallState() {
    const card = document.getElementById('infos-install-card');
    if (!card) return;
    if (isStandaloneDisplay()) {
        card.dataset.installed = '1';
    } else {
        delete card.dataset.installed;
    }
}

function showInstallButton() {
    const btn = document.getElementById('infos-install-btn');
    if (!btn) return;
    btn.hidden = false;
}

function hideInstallButton() {
    const btn = document.getElementById('infos-install-btn');
    if (!btn) return;
    btn.hidden = true;
}

async function triggerNativeInstall() {
    if (!_deferredInstallPrompt) return;
    try {
        _deferredInstallPrompt.prompt();
        const choice = await _deferredInstallPrompt.userChoice;
        if (choice && choice.outcome === 'accepted') {
            showInfosToast('Installation lancée 🎉');
        }
    } catch (_) {
        /* ignore */
    } finally {
        _deferredInstallPrompt = null;
        hideInstallButton();
    }
}

function bindInstallFlow() {
    markInstallState();

    window.addEventListener('beforeinstallprompt', event => {
        event.preventDefault();
        _deferredInstallPrompt = event;
        showInstallButton();
    });

    window.addEventListener('appinstalled', () => {
        _deferredInstallPrompt = null;
        hideInstallButton();
        markInstallState();
        showInfosToast('Bien joué, MyPoo est installé 💩');
    });

    const installBtn = document.getElementById('infos-install-btn');
    if (installBtn) installBtn.addEventListener('click', () => { void triggerNativeInstall(); });
}

/* ===== Init ===== */

function init() {
    bindShareButton();
    bindInstallFlow();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
    init();
}
